var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline grid grid__item_span-12 p0 m0"},[_c('h2',{staticClass:"uppercase grid__item_span-12 p0",style:({ color: _vm.item.headline_text_colour })},[_vm._v(_vm._s(_vm.item.project_headline))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b17db0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/headline.vue
// module id = null
// module chunks = 